export const GOI_PLATFORM_URL = process.env.NEXT_PUBLIC_PLATFORM_WEB_URL;
